import { defineMessages } from 'react-intl';

export default defineMessages({
    SaveCreditCard: {
        id: 'ml.common.component.MLCreditCardDetailsComponent.SaveCreditCard',
        defaultMessage: 'Customer confirms to store this payment information in the wallet and agrees to the electronic storage terms and conditions.'
    },
    ConsumerSaveCreditCard: {
        id: 'ml.common.component.MLCreditCardDetailsComponent.ConsumerSaveCreditCard',
        defaultMessage: 'By checking this box you agree to store your payment information in the wallet and agree to this website’s terms of use.'
    },
    PopeupCloseDisclaimer: {
        id: 'ml.common.component.MLCreditCardDetailsComponent.PopeupCloseDisclaimer',
        defaultMessage: 'Please close this pop-up window after the payment information is entered and saved.'
    }
});
